import { browserHistory } from 'react-router'
import { createVideoFromFiles, EDIT_USER } from '../actions'
import Cookies from 'js-cookie'
import { createAction } from 'redux-actions'

export function setCookie(name, value, expires) {
  if (process.env.NODE_ENV === 'development') {
    Cookies.set(name, value, { expires })
  } else {
    Cookies.set(name, value, { expires, domain: '.streamable.com' })
  }
}

export function processUploadedFiles(dispatch, files, group, maxLength, maxSize, uploadSource) {
  return new Promise((resolve, reject) => {
    let promises = []
    let filesArray = Array.from(files)
    filesArray.forEach((file) => {
      promises.push(new Promise((r) => {
        if (maxSize && file.size > maxSize * 1073741824) {
          dispatch(createAction(EDIT_USER)({ videoExceedsLimits: 'video-toolarge' }))
          reject()
          return
        }

        if (!maxLength) {
          r()
          return
        }

        getLengthOfVideoFile(file, (duration) => {
          if (duration && duration > maxLength) {
            dispatch(createAction(EDIT_USER)({ videoExceedsLimits: 'video-toolong' }))
            reject();
            return
          }
          r()
        })
      }))
    })

    Promise.all(promises).then(_ => {
      setCookie('dashboard', 'true', 90000)
      browserHistory.push('/')  
      dispatch(createVideoFromFiles(filesArray, { 
        upload_source: uploadSource || 'web',
      }))
      .then(() => {
        resolve()
      })
    })
  })
}

export function canPlayVideoFile(file) {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      resolve(false)
    }, 1000)
    let v = document.createElement('video')
    v.src = window.URL.createObjectURL(file);
    v.muted = true;
    v.style.visibility = 'hidden'
    v.addEventListener('error', function(ev) {
      resolve(false)
      clearTimeout(timeout)
    }, false);
    v.addEventListener('canplay', function(ev) {
      resolve(true)
      clearTimeout(timeout)
    }, false);
  })
}

export function getVideoFileMetadata(file, callback) {
  const video = document.createElement('video')
  video.preload = 'metadata'
  video.onloadedmetadata = () => {
    callback({
      duration: video.duration,
      height: video.videoHeight,
      width: video.videoWidth,
    })
  }
  video.onerror = () => {
    callback()
  }
  if (typeof file === 'string') {
    video.src = file
  } else {
    video.src = window.URL.createObjectURL(file)
  }
}

export function getLengthOfVideoFile(file, callback) {
  getVideoFileMetadata(file, (data) => {
    if (!data) {
      callback()
      return
    }
    callback(data.duration)
  })
}

export function secondsToString(seconds) {
  const numhours = Math.floor(seconds / 3600)
  seconds -= (numhours * 3600)
  const numminutes = Math.floor(seconds / 60)
  let numseconds = (seconds - (numminutes * 60)).toFixed(2)
  if (numseconds < 10) {
    numseconds = `0${numseconds}`
  }
  if (numhours === 0) {
    if (numminutes > 0) {
      return `${numminutes}:${numseconds}`
    }
    return `0${numseconds}`
  }
  let string = `${numminutes}:${numseconds}`
  if (numminutes < 10) {
    string = `0${string}`
  }
  return `${numhours}:${string}`
}

export function getBestFile(video) {
  const files = getFileList(video)
  if (!files.length) {
    return null
  }
  return files[0]
}

export function getBestSourceUrl(video) {
  const file = getBestFile(video)
  if (!file) return null;
  return file.url
}

export function getPlaybackUrl(video) {
  const files = getFileList(video)
  if (!files.length) {
    return null
  }
  if (files.length < 3) {
    return files[0].url
  }
  return files[1].url
}

export function getFileList(video) {
  let fileList = []
  for (let preset in video.files) {
    const f = video.files[preset]
    if (f.height && f.url) {
      fileList.push(f)
      f['preset'] = preset
    }
  }
  return fileList.sort((a,b) => b.height - a.height)
}

export function getFirstFile(video) {
  if (!video.files) {
    return null
  }
  let firstFile = null
  for (const preset of Object.keys(video.files)) {
    const file = video.files[preset]
    if (!firstFile) {
      firstFile = file
    } else if (firstFile.date_added > file.date_added) {
      firstFile = file
    }
  }
  return firstFile
}

export function getEmbedCode(video, options) {

  const { 
    autoplay,
    responsive,
    height,
    width,
    muted,
    tag,
    src,
    poster,
    branding,
    loop,
    skipdelay,
    timeout,
    type,
    noControls,
  } = options
  let code = '<iframe src="https://streamable.com/'
  let aspectRatio = width ? height / width : 0.5625
  
  const { shortcode } = video

  aspectRatio = video.height / video.width
  if (src) {
    code += 'customplayer'
  } else {
    code += `e/${shortcode}`
  }
  if (options.id) {
    code += `/${options.id}`
  }

  const params = []
  if (autoplay) {
    params.push('autoplay=1')
  }
  if (noControls) {
    params.push('nocontrols=1')
  }
  if (muted) {
    params.push('muted=1')
  }
  if (src) {
    params.push('src=' + encodeURIComponent(src))
    params.push('height=' + video.height.toString())
    params.push('width=' + video.width.toString())
  }
  if (poster) {
    params.push('poster=' + encodeURIComponent(poster))
  }
  if (tag) {
    params.push('tag=' + encodeURIComponent(tag))
  }
  if (branding) {
    params.push('logo=0')
    params.push('rightsholder=' + branding)
  } 
  if (loop === false) {
    params.push('loop=0')
  }
  if (type) {
    params.push('type=' + type)
  }
  if (skipdelay) {
    params.push('skipdelay=' + skipdelay)
  }
  if (timeout) {
    params.push('timeout=' + (timeout * 1000))
  }

  let first = true
  for (const param of params) {
    if (first) {
      code += '?'
    } else {
      code += '&'
    }
    code += param
    first = false
  }
  code += '"'

  let allow = autoplay ? ' allow="autoplay"' : ''

  if (height && width && !responsive) {
    code = `${code} width="${width}" height="${height}" frameborder="0" allowfullscreen${allow}></iframe>`
  } else {
    code = `<div style="width:100%;height:0px;position:relative;padding-bottom:${(aspectRatio * 100).toFixed(3)}%;">${code} frameborder="0" width="100%" height="100%" allowfullscreen${allow} style="width:100%;height:100%;position:absolute;left:0px;top:0px;overflow:hidden;"></iframe></div>`
  }
  return code
}

